import { useMutation } from '@tanstack/react-query';
import { PlanningTypes } from 'pages/admin/demand/planning/context/types/contextPrevision.type';
import api from 'services/api/api';

interface IFindHierachiesCompleteBody {
	cycle_id: number;
	hierarchy: string;
	company_area_id: number;
	filters_check: {
		product_ids: number[];
		commercial_hierarchy_ids: number[];
		customer_ids: number[];
	};
}

interface IFindHierachiesCompleteResponse {
	id: number;
	completed: 'none' | 'automatic' | 'manual';
}

export const findHierachiesComplete = async (
	planningType: PlanningTypes,
	body: IFindHierachiesCompleteBody,
	ids: number[]
): Promise<IFindHierachiesCompleteResponse[]> => {
	const response = await api.post(`/${planningType}/filter-completed`, {
		...body,
		ids,
	});
	return response.data;
};

export const useFindHierachiesComplete = (
	planningType: PlanningTypes,
	body: IFindHierachiesCompleteBody
) => {
	return useMutation({
		mutationFn: (ids: number[]) =>
			findHierachiesComplete(planningType, body, ids),
	});
};
